import { render, staticRenderFns } from "./AsuInfo.vue?vue&type=template&id=08e13c4c"
import script from "./AsuInfo.vue?vue&type=script&lang=js"
export * from "./AsuInfo.vue?vue&type=script&lang=js"
import style0 from "./AsuInfo.vue?vue&type=style&index=0&id=08e13c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports